<div class="container-fluid py-4">
    <!-- Header del reporte -->
    <div class="row align-items-center mb-4">
        <div class="col-md-4 text-center text-md-start">
            <img class="logo img-fluid" src="./assets/img/logo.jpeg" alt="Logo Uturunco Studio"
                style="max-height: 80px;">
            <div class="mt-2">
                <h5 class="mb-0 fw-bold">Uturunco Studio</h5>
                <small class="text-muted">Empresa independiente de desarrollo de software</small>
            </div>
        </div>

        <div class="col-md-4 text-center">
            <h3 class="mb-1 fw-bold text-primary">Reporte por Producto</h3>
            <h6 class="text-muted">Movimientos y stock actual</h6>
        </div>

        <div class="col-md-4 text-center text-md-end">
            <small class="text-muted">
                Resistencia, Chaco<br>
                {{ fecha | date:'dd MM yyyy' }}
            </small>
        </div>
    </div>

    <!-- Filtros -->
    <div class="card shadow-sm mb-4">
        <div class="card-body">
            <div class="row g-3 align-items-end">
                <!-- Selector de producto -->
                <div class="col-md-4">
                    <label class="form-label fw-bold">Producto</label>
                    <app-cb-mercaderia-2 [require]="false" [dibujar]="item" (select)="itemSel($event)">
                    </app-cb-mercaderia-2>
                </div>

                <!-- Fecha desde -->
                <div class="col-md-3">
                    <label class="form-label fw-bold">Fecha desde</label>
                    <input type="date" class="form-control" id="fechade" [value]="fechade | date:'yyyy-MM-dd'"
                        (input)="fechade = parseDate($event.target.value)" required />
                </div>

                <!-- Fecha hasta -->
                <div class="col-md-3">
                    <label class="form-label fw-bold">Fecha hasta</label>
                    <input type="date" class="form-control" id="fechaha" [value]="fechaha | date:'yyyy-MM-dd'"
                        (input)="fechaha = parseDate($event.target.value)" required />
                </div>

                <!-- Botón buscar con loading -->
                <div class="col-md-2">
                    <label class="form-label invisible d-block">Acción</label>
                    <button class="btn btn-primary w-100" [disabled]="loading || !item?.id" (click)="getList()">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"
                            aria-hidden="true"></span>
                        {{ loading ? 'Consultando...' : 'Buscar' }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Resultados -->
    <div class="card shadow-sm">
        <div class="card-header bg-light">
            <h5 class="mb-0">Movimientos del producto</h5>
            <small class="text-muted" *ngIf="item?.nombre">
                {{ item.nombre }} — Stock actual: <strong>{{ stockActual }}</strong>
            </small>
        </div>

        <div class="card-body p-0">
            <!-- Loading overlay -->
            <div *ngIf="loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-3 text-muted">Obteniendo movimientos...</p>
            </div>

            <!-- Tabla con datos -->
            <div class="table-responsive" *ngIf="!loading">
                <table id="tblData" class="table table-hover table-bordered mb-0">
                    <thead class="table-dark">
                        <tr>
                            <th>Tipo transacción</th>
                            <th>Fecha y hora</th>
                            <th>Cantidad</th>
                            <th>Stock después del movimiento</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items">
                            <td>{{ item.tipo }}</td>
                            <td>{{ item.fecha | date:'dd-MM-yyyy HH:mm' }}</td>
                            <td class="text-center">{{ item.cantidad }}</td>
                            <td class="text-center fw-bold">{{ item.stock_actual }}</td>
                        </tr>

                        <!-- Mensaje sin datos -->
                        <tr *ngIf="items?.length === 0 && !loading">
                            <td colspan="4" class="text-center text-muted py-4">
                                <i class="fas fa-info-circle fa-2x mb-2"></i><br>
                                No se encontraron movimientos para el producto y período seleccionado.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Footer con resumen -->
        <div class="card-footer text-end bg-light" *ngIf="items?.length > 0 && !loading">
            <small class="text-muted">
                Total de movimientos encontrados: <strong>{{ items.length }}</strong>
            </small>
        </div>
    </div>

    <!-- ... después de la tabla ... -->

    <div class="card shadow-sm mt-4" *ngIf="items?.length >= 5 && !loading">
        <div class="card-header bg-light">
            <h5 class="mb-0">Evolución del stock en el período</h5>
        </div>
        <div class="card-body">
            <div class="chart-container" style="position: relative; height: 300px; width: 100%;">
                <canvas baseChart [datasets]="lineChartDatasets" [labels]="lineChartLabels" [options]="lineChartOptions"
                    [legend]="true" [chartType]="lineChartType">
                </canvas>
            </div>
        </div>
    </div>

    <!-- Mensaje si hay pocos datos -->
    <div class="alert alert-info mt-3" *ngIf="items?.length > 0 && items?.length < 5 && !loading">
        <i class="fas fa-info-circle me-2"></i>
        Hay pocos movimientos en este período. El gráfico se muestra solo con 5 o más registros.
    </div>
</div>